import { Component, OnInit, OnDestroy } from '@angular/core';
import { UiService } from '../ui.service';
import { AppServiceService } from '../app-service.service';
import { designerAnimatePage } from '../animation/animate';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-designers',
  templateUrl: './designers.component.html',
  styleUrls: ['./designers.component.scss'],
  animations: [designerAnimatePage],
  host: { '[@designerAnimatePage]': '' }
})
export class DesignersComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  mobile:boolean;
  
  private post:any;
  private designers:any;
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private UI: UiService, 
    private app:AppServiceService,
    private api:ApiService,
    private route: ActivatedRoute
  ) { 
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
    })
    this.mobile = this.UI.widthMobile();
  }

  getSlug(url:string){
    return url.split('/')[4];
  }

  ngOnInit() {
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })
    
    this.app.blackStyle.next(true);
    this.app.normalMenu.next(true);
    this.app.showLeftPanel.next(true); 
    setTimeout(() => {
      this.app.title.next(this.post.title);
      this.app.titleLeftPanel.next(true);
      this.UI.slideDesigners(); 
      this.app.activeMenu.next(true);
      
    }, 1200);
  }

  /**
   *  get cords item designer
   *  @param event event lisener function 
  */

  getCoodsDesigner(event){
    let bounds = event.target.getBoundingClientRect();
    let leftMargeDesigner:number;
    leftMargeDesigner = Math.round(bounds.left);
    this.app.indentationDesignerImage = leftMargeDesigner;
  }

  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);
    this.app.blackStyle.next(false);
    this.app.normalMenu.next(true);
    this.app.activeMenu.next(false);
    //menu
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    }, 500);
    
    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/designers/designers.component.ts